import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { FormControl } from "../../../../../common/components/libs";
import { SnackbarType } from "../../../../../stores/common";
import ClientOrdersStoreContext from "../store/context";
import {Trans, useTranslation} from "react-i18next";


const TimePicker = () => {
    const { generalStore } = useStores();
    const ordersStore = useContext(ClientOrdersStoreContext);
    const filter = ordersStore.filter;
    const {i18n, t} = useTranslation(["general"]);
    const locale = i18n.language;

    return <>
        <div>
            <Grid container spacing={4}
                  style={{
                      maxWidth: 500,
                      marginTop: 5
                  }}>
                <Grid item md={6} xs={6} lg={6}>
                    <FormControl>
                        <DatePicker
                            label={t("general:from")}
                            value={filter.createdAfter}
                            onChange={(value: Date) => {
                                ordersStore.setOrdersFilter({
                                    ...filter,
                                    createdAfter: value
                                });
                                ordersStore.reloadOrders();
                                generalStore.showSnackbar({
                                    type: SnackbarType.success,
                                    title: t("general:labelOfUpdating")
                                });
                            }}
                        />
                    </FormControl>
                </Grid>

                <Grid item md={6} xs={6} lg={6}>
                    <FormControl>
                        <DatePicker
                            label={t("general:to")}
                            value={filter.createdBefore}
                            onChange={(value: Date) => {

                                ordersStore.setOrdersFilter({
                                    ...filter,
                                    createdBefore: value
                                });
                                ordersStore.reloadOrders();
                                generalStore.showSnackbar({
                                    type: SnackbarType.success,
                                    title: t("general:labelOfUpdating")
                                });
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </div>
    </>;
};


export default observer(TimePicker);
